/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';
import _ from 'lodash';
import { Route } from 'react-router';
import { BookContextProvider } from '../pages/v2/book/BookContextProvider';
import { ReadChapterView } from '../pages/v2/book/ReadChapterView';
import { BookView } from '../pages/v2/book/BookView';

export const NewBookRoutes = (props: any) => (
  <Route
    path={`/v2/livro/:bookId/:editionId?/:chapterId?/:chapterTitle?`}
    render={(props) => {
      const chapterId = _.get(props, 'match.params.chapterId');
      const isValidId = Number(chapterId);
      return (
        <BookContextProvider {...props}>
          <>
            {chapterId && Number.isInteger(isValidId) && <ReadChapterView />}
            <BookView {...props} />
          </>
        </BookContextProvider>
      );
    }}
  />
);
